import {
  Button,
  ButtonRootProps,
  Modal as ModalDS,
  ModalRootProps,
} from '@iveco-ti/iveco-ds'
import { useTranslation } from 'react-i18next'

import { useModalProvider } from '../hooks/useModalProvider'

export function Modal() {
  const { t } = useTranslation('common')
  const {
    type = 'primary',
    title,
    description,
    cancelText,
    confirmText,
    isLoading,
    onCancel,
    onConfirm,
    resetModal,
  } = useModalProvider()

  const handleCancel = async () => {
    if (onCancel) onCancel()
    resetModal()
  }

  const handleConfirm = async () => {
    if (onConfirm) await onConfirm()

    resetModal()
  }

  const BUTTON_COLORS_BY_TYPE: Record<
    NonNullable<ModalRootProps['type']>,
    ButtonRootProps['color']
  > = {
    danger: 'danger',
    primary: 'brand',
    warning: 'warning',
  }

  return (
    <ModalDS.Root clickOutside id="global-modal">
      <ModalDS.Header type={type}>
        <ModalDS.Icon type={type} />

        <h1 className="text-3xl font-semibold text-base-800">{title}</h1>
      </ModalDS.Header>

      {description && (
        <ModalDS.Body className="flex w-full items-center justify-center text-center">
          <p className="mt-1 text-base-500">{description}</p>
        </ModalDS.Body>
      )}

      <ModalDS.Footer>
        <div className="w-full flex items-center justify-center my-3 gap-4">
          <Button.Root
            variant="secondary"
            onClick={handleCancel}
            color={BUTTON_COLORS_BY_TYPE[type]}
          >
            {cancelText || t('components.modal.cancel_button.label')}
          </Button.Root>

          <Button.Root
            variant="primary"
            onClick={handleConfirm}
            isLoading={isLoading}
            color={BUTTON_COLORS_BY_TYPE[type]}
          >
            {confirmText || t('components.modal.confirm_button.label')}
          </Button.Root>
        </div>
      </ModalDS.Footer>
    </ModalDS.Root>
  )
}
